export enum Role {
  BigPuntos = 'Big Puntos',
  Autonomo = 'Autonomo',
  Empleado = 'Empleado'
}
